export const EMPTY_STATE_MIN_HEIGHT = 220;
